module.exports = require("worker-plugin");